import React, { useMemo, useCallback } from "react";
import { FormattedMessage } from "react-intl";

import { Icon, glyphs } from "@treelab/panda";

import { IFormItemChangeValue } from "../../../../types/form-type";

import {
  Container,
  TitleContainer,
  TitleMain,
  ChildrenContainer,
  Vertical,
} from "./styled";

interface IProps {
  id: string;
  labelId?: string;
  onChange: (value: IFormItemChangeValue) => void;
  value: boolean;
  children: React.ReactNode[];
  allowFolding: boolean;
}

const FormBlock: React.FC<IProps> = ({
  labelId,
  children,
  id,
  allowFolding,
  onChange,
  value,
}) => {
  const show = useMemo(() => {
    if (!allowFolding) return true;
    return !!value;
  }, [value, allowFolding]);

  const handleClickTitle = useCallback(() => {
    if (allowFolding) {
      onChange({ [id]: !value });
    }
  }, [onChange, allowFolding, value, id]);

  return (
    <Container id={id}>
      {labelId && (
        <TitleContainer>
          <Vertical />
          <TitleMain onClick={handleClickTitle} allowFolding={allowFolding}>
            <FormattedMessage id={labelId} />
            {allowFolding && (
              <Icon
                icon={glyphs.ARROW_RIGHT}
                size={{ width: 9, height: 9 }}
                style={{
                  transform: `rotate(${show ? "-90deg" : "90deg"})`,
                  color: "#83868F",
                }}
              />
            )}
          </TitleMain>
        </TitleContainer>
      )}
      <ChildrenContainer show={show}>{children}</ChildrenContainer>
    </Container>
  );
};

export default FormBlock;
